/** 資產負債版本來源（API 中文或數字） */
export const balanceSheetSourceMeta = {
    自行上傳: { color: 'blue', label: '自行上傳' },
    盤點版本: { color: 'purple', label: '盤點版本' },
    諮詢版本: { color: 'green', label: '諮詢版本' },
    0: { color: 'blue', label: '自行上傳' },
    1: { color: 'purple', label: '盤點版本' },
    2: { color: 'green', label: '諮詢版本' }
};

export function getBalanceSheetSourceMeta(source) {
    if (source === null || source === undefined || source === '') {
        return { color: 'default', label: '—' };
    }
    return (
        balanceSheetSourceMeta[source] ||
        balanceSheetSourceMeta[String(source)] || {
            color: 'default',
            label: String(source)
        }
    );
}

/** 版本狀態 */
export const balanceSheetStatusMeta = {
    編輯中: { color: 'processing', label: '編輯中' },
    完成: { color: 'success', label: '完成' },
    0: { color: 'processing', label: '編輯中' },
    1: { color: 'success', label: '完成' }
};

export function getBalanceSheetStatusMeta(status) {
    if (status === null || status === undefined || status === '') {
        return { color: 'default', label: '—' };
    }
    return (
        balanceSheetStatusMeta[status] ||
        balanceSheetStatusMeta[String(status)] || {
            color: 'default',
            label: String(status)
        }
    );
}

/** 諮詢師建立新版時可選的來源 */
export const consultantNewVersionSourceOptions = [
    { value: 2, label: '諮詢版本', description: '本次諮詢產出，標記為諮詢師建立' },
    { value: 1, label: '盤點版本', description: '盤點用途，標記為盤點人員建立' }
];

/** 版本時間顯示（不含秒） */
export function formatVersionDateTime(value) {
    if (!value) return '—';
    const s = String(value).trim();
    return s.replace(/^(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}):\d{2}$/, '$1').slice(0, 16);
}

/** 表格／下拉選單用的版本名稱（不以 ID 呈現） */
export function formatVersionDisplayName(version) {
    const dt = formatVersionDateTime(version?.updated_at || version?.created_at);
    const name = String(version?.name || '').trim();
    if (name && !/^\d+$/.test(name)) {
        return `${name}（${dt}）`;
    }
    return dt;
}

export function formatVersionSelectLabel(version) {
    const title = formatVersionDisplayName(version);
    const source = version?.source || '—';
    const status = version?.status || '—';
    return `${title} · ${source} · ${status}`;
}

export function formatSheetAmount(value) {
    if (value === null || value === undefined || value === '') return '—';
    const num = Number(value);
    if (!Number.isFinite(num)) return '—';
    return num.toLocaleString('zh-TW');
}

function parseSheetAmount(value) {
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    if (!Number.isFinite(num)) return null;
    return num;
}

/** 完整千分位（hover 提示、無法用萬表示時） */
export function formatAmountFull(value) {
    const num = parseSheetAmount(value);
    if (num === null) return '—';
    return num.toLocaleString('zh-TW', { maximumFractionDigits: 0 });
}

/**
 * 諮詢師工作台：金額可整除 1 萬時顯示「N萬」（如 10000000→1000萬），否則完整數字（如 99999999）
 */
export function formatAmountCompact(value, { zeroAsDash = false } = {}) {
    const num = parseSheetAmount(value);
    if (num === null) return '—';
    if (num === 0) return zeroAsDash ? '—' : '0';

    const abs = Math.abs(num);
    const sign = num < 0 ? '-' : '';

    if (abs >= 10000 && abs % 10000 === 0) {
        const wan = abs / 10000;
        return `${sign}${wan.toLocaleString('zh-TW', { maximumFractionDigits: 0 })}萬`;
    }

    return `${sign}${abs.toLocaleString('zh-TW', { maximumFractionDigits: 0 })}`;
}

export function formatAmountCompactWithDash(value) {
    return formatAmountCompact(value, { zeroAsDash: true });
}
